import apiUrl from '../../../../constants'
import axios from "axios";
import CryptoJS from "crypto-js";
import Paginate from "vuejs-paginate";
import { Validator } from "vee-validate";
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../../common/PageTrackerHelper'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import keycloak from '../../../../common/Keycloak';

export default {
  name: "HubMarkLostDebit",
  components: {
    VueElementLoading,
    Paginate,
    Multiselect,
  },
  mixins: [PageTracker],
  props: [],
  data() {
    return {
      search: '',
      max: 500,
      comments: '',
      shipmentlogmodal: false,
      pageno: 0,
      pagecount: 0,
      fromDate: new Date().toISOString().split("T")[0],
      toDate: new Date().toISOString().split("T")[0],
      processmode: "",
      status: "",
      returnArray: [],
      agentDetailss: [],
      agentShipmentDetails: [],
      resultCount: '',
      adjustDebitAmount: 0,
      isDebitPersonSelected: "",
      DocketNumber: "",
      ChallanNumber: "",
      deliveyolduserid: "",
      LostShipInfo: {
        shippingid: '',
        origin: '',
        destination: '',
        currentHub: '',
        currentHubID: '',
        netAmt: 0,
        NetShipmentValue: 0,
        ShipmentStatus: '',
        ActionStatus: '',
        DebitAmt: 0,
        status: '',
        DebitFrom: '',
        DebitMode: '',
        DebitConserPerson: '',
        Courier: "",
        Coloader: "",
        Vendor: "",
        RSC: "",
        BranchDebit:"",
        DebitAmount: 0
      },

      ClientName: '',
      ClientID: '',
      CurrentHubZoneID: '',
      CurrentHubZoneName: '',
      ServiceCenter: false,
      supeAgentCourier: false,
      Coloader: false,
      LocalVendor: false,
      debitModeflag: false,
      attchmentFlag: false,
      DocketNumebr: false,
      userCategory: [],
      DebitFromObj: [{ "id": "ServiceCenter", "Debit_name": "ServiceCenter" },
      { "id": "Courier", "Debit_name": "SuperAgent" },
      { "id": "Coloader", "Debit_name": "Coloader" },
      { "id": "Vendor", "Debit_name": "LocalVendor" },
      { "id": "NetworkVendor", "Debit_name": "NetworkVendor" },
      {"id": "RSC", "Debit_name": "RSCOwner"},
      {"id": "BranchDebit", "Debit_name": "BranchDebit"}
    ],
      DebitModeObj: [],
      CourierObj: [],
      VendorObj: [],
      users: [],
      shipmentLog: [],
      selected: [],
      allSelected: false,
      userIds: [],
      selectedItems: [],
      selectedRSCHubs: [],
      selectAllItems: false,
      ColoaderObj: [],
      empDetails: [],
      UpdateCurrentHubId: '',
      parentHubObj: [],
      danger: '',
      attachmentPath: '',
      isAPICallFlag: true,
      debitPersonAmount: [],
      debitPersonPercent: [],
      oldcourieroutsourcingId: [],
      file: '',
      Loading: false,
      getUploadError: [],
      uploadError: '',
      validated: true,
      DefaultDebitCategory: [],
      DebitCatLoader: false,
      DebitUserSelectedOptions: [],
      loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      debitCatLoader: "",
      debitCatSelected: [],
      isDebitPersonLoading: false,
      isSaveLoading: false,
      dataLoading: false,
      filteredEmpTotalCount: 0,
      selectedfilteredEmpCount: 0,
      keyUserId: 'userid',
      keyName: 'username',
      amountExceedError: false,
      selectAlluser: false,
      shippingIdForMeta: "",
      NetPaymentArr: [],
      TableDetails: [],
      apiResponseforTable: [],
      modelValue: false,
      TotalSum: 0,
      styleObjectFailure: {
        'text-color': 'red',
        'color':'red'
      },
      styleObjectSuccess: {
        'text-color': 'green',
        'color':'green'
      },
      GstValue: 0,
      selectAllItems: false,
      rscShipments: false,
      rscOwnerList: [],
      globalShippingid : null,
      utype: [2,3],
      userDataKey : '',
      hubList:[],
      RSCObj:[],
      BranchDebit:'',
      IsRSC:false,
      IsRSCVal:'',
      userInfo:{},
      // rscShipments: false,
      // rscOwnerList: [],
      losthubconfig: '',
      isLostNewFeaturesisOnThisHub: false,
      unfilterdEmpDetails : [],
      LoggedInUserJobProfile: '',
      sortByVerticalAsc: true,
      sortByTypeAsc: true,
      sortByVerticalAsc: true,
      sortPriority: ['Vertical', 'Type']
    }
  },
  computed: {
    // filteredEmployees: function () {
    //   var self = this;
    //   this.filteredEmpTotalCount = this.empDetails.length
    //   return this.empDetails.filter(function (emp) { return emp.username.toLowerCase().indexOf(self.search.toLowerCase()) >= 0; });
    //   //return this.customers;
    // },
    filteredEmployees() {
      const searchLower = this.search.toLowerCase();

      let filtered = this.empDetails.filter(emp => {
        return (
          emp.username.toLowerCase().includes(searchLower) ||
          String(emp.EmployeeID).toLowerCase().includes(searchLower)
        );
      });

      // Apply sorting based on priority
      return filtered.sort((a, b) => {
        for (let key of this.sortPriority.slice().reverse()) {
          let valA = (a[key === 'Type' ? 'EmpTypeName' : 'Vertical'] || '').toLowerCase();
          let valB = (b[key === 'Type' ? 'EmpTypeName' : 'Vertical'] || '').toLowerCase();

          let asc = key === 'Type' ? this.sortByTypeAsc : this.sortByVerticalAsc;

          if (valA < valB) return asc ? -1 : 1;
          if (valA > valB) return asc ? 1 : -1;
          // if equal, go to next sort key
        }
        return 0;
      });
    }
  },
  created: async function () {
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    if (this.$route.query.shippingid) {
      this.getLostShipmentDetails(this.$route.query.shippingid);
    } else if(this.$route.query.id){
      this.getLostShipmentDetails(this.$route.query.id);
    } else{
      this.$router.push('/MarkLostShipment');
    }
    this.pageno = 0;
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    console.log('userdetail', userdetail);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    this.hubdetails = userdetail.hubdetails[0];
    this.userInfo = userdetail;
    this.LoggedInUserJobProfile = userdetail.jobProfile

    var IsRSCEncrypt = window.localStorage.getItem('IsRSC')
    var bytes = CryptoJS.AES.decrypt(IsRSCEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    this.IsRSCVal = JSON.parse(plaintext);
    this.GetGst();

    var IshubconfigsEncrypt = window.localStorage.getItem('hubconfigs')
    var bytes = CryptoJS.AES.decrypt(IshubconfigsEncrypt.toString(), this.userDataKey);
    this.losthubconfig = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    let isLostNewFeatures = await this.getDataFromRedisbyKeyNameCommonFun({
      "key": "newLostDebitUserRestrictionHubLevelConfig"
    })
    console.log('isLostNewFeatures --------->>', isLostNewFeatures);
    this.isLostNewFeaturesisOnThisHub = isLostNewFeatures.includes(0) || isLostNewFeatures.includes(this.hubdetails) ? true : false;
    console.log('this.isLostNewFeaturesisOnThisHub -asd------->>', this.isLostNewFeaturesisOnThisHub);

    this.getDebitFromDetailsFromRedis = await this.getDataFromRedisbyKeyName({
      "key": "lostdebitfromtypesconfig"
    })
    let defineConfig = {
      loggedInHubdetails: this.losthubconfig,
      debitfromtypeconfigs: this.getDebitFromDetailsFromRedis ? this.getDebitFromDetailsFromRedis: false,
      loggedinuserRole: this.LoggedInUserJobProfile,
      isRsc: this.IsRSCVal,
      hubid: this.hubdetails,
      userDept: this.userInfo.department ? this.userInfo.department : false
    }
    this.setDebitFromTypeOptionsBasedonConfig(defineConfig)
    console.log('this.getDebitFromDetailsFromRedis ------->>', this.getDebitFromDetailsFromRedis);

  },
  watch: {
    adjustDebitAmount(val) {
      let checkReminder = val.split(".")
      if (checkReminder[0] != 0) {
        this.amountExceedError = true
      } else {
        this.amountExceedError = false
      }
    }
  },
  methods: {
    getDataFromRedisbyKeyName(keypayload){
      return new Promise((resolve, reject) => {
        try {
          axios.post(apiUrl.api_url + 'rediscluster/get', keypayload)
            .then((response) => {
              if (response.data.code === 200) {
                resolve(JSON.parse(response.data.message))
              }
              if (response.data.message == false) {
                resolve(false);
              }
            })
        } catch (e) {
          console.log("Unable to read data from redis.!", e);
        }
      })
    },
    async setDebitFromTypeOptionsBasedonConfig(reqparams){
      try {
        let { loggedInHubdetails, debitfromtypeconfigs,  loggedinuserRole, isRsc, hubid, userDept } = reqparams;
        // console.log("debitfromtypeconfigs ---------->>", debitfromtypeconfigs);
        console.log("reqparams userDept---------->>", userDept);

        if( userDept && (userDept.toLowerCase() == 'line haul' || userDept.toLowerCase() == 'linehaul')) {
          // console.log('this is line haul department.!', this.DebitFromObj);
          this.DebitFromObj = this.DebitFromObj.filter((opt) => opt.Debit_name.toLowerCase() == 'networkvendor' ||  opt.Debit_name.toLowerCase() == 'localvendor' || opt.Debit_name.toLowerCase() == 'coloader');
          return true;
        }

        if (debitfromtypeconfigs && debitfromtypeconfigs.length ) {
          let getfilteredData = debitfromtypeconfigs.filter((obj) => obj.centertype == loggedInHubdetails.CenterType && obj.soc == loggedInHubdetails.SOC);
          console.log('getfilteredData ------------>>', getfilteredData);
          if (getfilteredData.length){
            let debitoptions = getfilteredData[0].options.split(",").map(option => option.trim().toLowerCase());
            this.DebitFromObj = this.DebitFromObj.filter((debitoption) => {
              if(debitoptions.includes(debitoption.Debit_name.toLowerCase().trim())) {
                return debitoption;
              }
            })
          }
        }

        //hub basis filter.
        if ( isRsc !=0 ) {
          this.IsRSC=true;
          this.DebitFromObj = this.DebitFromObj.filter((opt) => opt.Debit_name.toLowerCase() != 'servicecenter' &&  opt.Debit_name.toLowerCase() != 'superagent');
          this.LostShipInfo.DebitFrom="RSC"
          this.BindDebitFrom()
        } else {
          this.DebitFromObj = this.DebitFromObj.filter((opt) => opt.Debit_name.toLowerCase() != 'rscowner');
        }
        console.log('Final Debit from types  ---------->>', this.DebitFromObj);
        let outsourcingdetails = await this.getOutSourcingDetailsfromdb(hubid);
        if( outsourcingdetails.data.length == 0) {
          this.DebitFromObj = this.DebitFromObj.filter((opt) => opt.Debit_name.toLowerCase() != 'superagent');
        }
      } catch(e) {
        console.log("Catch Exception..!!", e);
        return true;
      }
    },
    getOutSourcingDetailsfromdb(hubid) {
      return new Promise((resolve, reject) => {
        try {
          axios.post(apiUrl.api_url + 'external/OutSourcingAgentLIst', { "HubID": hubid, "EntityType": "Agent" })
          .then((response) => {
            if (response.data.code === 200) {
              resolve({data: response.data.data, message:"success", "code": 200})
            } else {
              resolve({data: [], message:response.data.message, "code": 204})
            }
          })
          .catch((httpException) => {
            this.$alertify.error("Courier data not found");
            console.error('exception is:::::::::', httpException)
          })
        } catch(e) {
          console.log('Unable to get Outsourcing details.!!', e);
        }
      })
    },
    GetGst() {
      let reqpayload = {
        "key": "isGstValue"
      }
      axios.post(apiUrl.api_url + 'rediscluster/get', reqpayload)
        .then((response) => {
          if (response.data.code === 200) {
            let gstVal = JSON.parse(response.data.message)
            this.GstValue = gstVal.gst
          }
          if (response.data.message == false) {
            this.$alertify.error("GST Value Not found");
          }
        })
    },
    setcheckboxGst($event, item, index) {
      if ($event.target.checked == true) {
        this.SetPenaltyAmt(true, item, index);
      } else {
        this.SetPenaltyAmt(false, item, index)
      }
    },
    SetPenaltyAmt(item, index) {
      this.TableDetails[index].Penalty  = this.TableDetails[index].Penalty ? parseFloat(this.TableDetails[index].Penalty).toFixed(2) : 0
      let TotalAmount = 0
      if (item.Gst == false) {
        TotalAmount = parseFloat(this.TableDetails[index].GreaterDebitAMt) + parseFloat(this.TableDetails[index].GreaterDebitAMt * (this.GstValue / 100))
      } else {
        TotalAmount = this.TableDetails[index].GreaterDebitAMt
      }
      this.TableDetails[index].TotalDebitAmt = (parseFloat(TotalAmount) + parseFloat(this.TableDetails[index].Penalty ? this.TableDetails[index].Penalty : 0)).toFixed(2)
      $(`#index_${index}`).html((parseFloat(TotalAmount) + parseFloat(this.TableDetails[index].Penalty ? this.TableDetails[index].Penalty : 0)).toFixed(2))
      this.CalculateTotal();
    },
    CalculateTotal() {
      let Amount = 0;
      let len = this.TableDetails.length
      for (let i = 0; i < len; i++) {
        Amount += parseFloat(this.TableDetails[i].TotalDebitAmt)
      }
      this.TotalSum = parseFloat(Amount).toFixed(2)
      this.calculateDebitAmout(this.TotalSum, 100);
    },
    getLostShipmentDetails(shippingIds) {
      this.dataLoading = true
      this.globalShippingid = shippingIds ? JSON.parse(shippingIds) : ""
      let reqObj = { ShippingID: shippingIds ? JSON.parse(shippingIds) : "" }
      if (!reqObj.ShippingID) {
        this.$alertify.error("Shipment parameters not found");
        this.dataLoading = false
        return false;
      }
      axios.post(apiUrl.api_url + 'shipmentLost/getShipmentDetails', reqObj)
        .then(async (response) => {
          if (response.data.code === 200) {
            this.TableDetails = response.data.data;
            this.getShipmentDetailsfromUpdateshipment();

            // let penalty_details = await this.getDataFromRedisbyKeyNameCommonFun({
            //   "key": "lost_penaltyconfigs"
            // })
            // if (this.TableDetails[0].IsRSC == '1') {
            //   this.rscShipments = true;
            //   this.LostShipInfo.DebitFrom = 'ServiceCenter';
            //   this.BindDebitFrom();
            // }
            let resLen = this.TableDetails.length
            for(let i=0;i<resLen;i++){
            this.TableDetails[i].OctroiMRP = this.TableDetails[i].OctroiMRP != null ? this.TableDetails[i].OctroiMRP : 0
            this.TableDetails[i].NetPayment = this.TableDetails[i].NetPayment != null ? this.TableDetails[i].NetPayment : 0
             if(parseFloat(this.TableDetails[i].OctroiMRP) > parseFloat(this.TableDetails[i].NetPayment)){
              this.TableDetails[i].GreaterDebitAMt =parseFloat(this.TableDetails[i].OctroiMRP)
             }
             else{
              this.TableDetails[i].GreaterDebitAMt = parseFloat(this.TableDetails[i].NetPayment)

             }
             this.TableDetails[i].Gst = true;
             this.TableDetails[i].Penalty = 0;
             //  if (this.TableDetails[i].IsRSC == '1' && this.TableDetails[i].NotifyNoInfoDetail.rscownername != null) {
            //     this.rscOwnerList.push(this.TableDetails[i].NotifyNoInfoDetail.rscownername)
            //  }
              let get_lost_sub_reason;
              if (this.$route.query.reason) {
                get_lost_sub_reason= this.$route.query.reason[1];
              } else {
                get_lost_sub_reason = this.TableDetails[i].SubLostReason
              }

              // if( get_lost_sub_reason && penalty_details.length ) {
              //   let matchedReason = penalty_details.find(obj => obj.lost_sub_reason === get_lost_sub_reason);
              //   if (matchedReason) {
              //     this.TableDetails[i].Penalty = parseFloat(this.TableDetails[i].GreaterDebitAMt) *  parseFloat(matchedReason.penalty_multiplier)
              //   }
              // }

              this.TableDetails[i].TotalDebitAmt = parseFloat(this.TableDetails[i].GreaterDebitAMt + this.TableDetails[i].Penalty);
              this.TotalSum = parseFloat(this.TotalSum) + parseFloat(this.TableDetails[i].TotalDebitAmt);

            }
            let unique = []; //For removing duplicates
            this.rscOwnerList.forEach(element => {
                if (!unique.includes(element)) {
                    unique.push(element);
                }
            });
            this.rscOwnerList = unique;
            let getResult = response.data.data;
            let getNetPayment = getResult[0].NetPayment != null ? getResult[0].NetPayment : 0
            let getOctroiMRP = getResult[0].OctroiMRP != null ? getResult[0].OctroiMRP : 0

            this.LostShipInfo = {
              shippingid: getResult[0].ShippingID,
              origin: getResult[0].OriginHubName,
              destination: getResult[0].FinalDestinationName,
              currentHub: getResult[0].CurrentHubName,
              netAmt: getResult[0].NetPayment != null ? getResult[0].NetPayment : 0,
              NetShipmentValue: getResult[0].OctroiMRP != null ? getResult[0].OctroiMRP : 0,
              ShipmentStatus: getResult[0].ShipmentStatus,
              ActionStatus: 'MarkLost',
              status: getResult[0].Status,
              currentHubID: getResult[0].CurrentHubId,
              currentHubZoneID : getResult[0].CurrentHubZoneID,
              DebitAmount: parseFloat(getNetPayment) > parseFloat(getOctroiMRP) ? getNetPayment : getOctroiMRP,
              DebitFrom: '',
              DebitMode: '',
              Courier: '',
              RSC:'',
              BranchDebit:getResult[0].OriginHubName,
              Coloader: '',
              Vendor: ''
            }
            this.ClientName = getResult[0].ClientName;
            this.ClientID = getResult[0].ClientID;
            this.CurrentHubZoneID = getResult[0].CurrentHubZoneID;
            this.CurrentHubZoneName = getResult[0].CurrentHubZoneName;
            this.dataLoading = false
          }
          else {
            this.TableDetails = [];
            this.LostShipInfo = [];
            this.dataLoading = false
          }
          // this.IsRSCVal=1;
        // if(this.IsRSCVal!=0){
        //   this.IsRSC=true;
        //   this.LostShipInfo.DebitFrom="RSC"
        //   this.DebitFromObj= [
        //       { "id": "Coloader", "Debit_name": "Coloader" },
        //       { "id": "Vendor", "Debit_name": "LocalVendor" },
        //       { "id": "NetworkVendor", "Debit_name": "NetworkVendor" },
        //       {"id": "RSC", "Debit_name": "RSCOwner"},
        //     ]
        //     this.BindDebitFrom()
        // }
        })
        .catch((httpException) => {
          this.dataLoading = false
          this.$alertify.error("Lost Shipment data not found");
          console.error('exception is:::::::::', httpException)
        })
    },
    getShipmentDetailsfromUpdateshipment() {
      if (this.TableDetails[0].ShippingID != undefined && this.TableDetails[0].ShippingID != []) {
        let reqObj = { shippingID: this.TableDetails[0].ShippingID ? this.TableDetails[0].ShippingID.toString() : ""}
        axios.post(apiUrl.api_url + 'shipmentMisrout/getShipmemtsdetails',reqObj)
          .then((response) => {
            if (response.data.code === 200) {
              let UpdateshipmentDetails = response.data.data;
              this.UpdateCurrentHubId = UpdateshipmentDetails.CurrentHubID;
              try {
                let TrackerInfo = {
                  projectname: "Last Mile",
                  type: "Web",
                  userid: this.localuserid,
                  username: this.localusermailid,
                  routeurl: "shipmentMisrout/getShipmemtsdetails",
                  meta: {
                    event: "shipmentMisrout-getShipmemtsdetails",
                    shipmentId: reqObj ? (reqObj.shippingID ? reqObj.shippingID : null) : null,
                    hubId: this.hubdetails ? this.hubdetails : null,
                    remarks: "Frontend",
                  },
                };
                this.PageTracker(TrackerInfo);
              } catch (error) {
                console.log(error);
              }
            }
            else {
              this.UpdateCurrentHubId = this.TableDetails[0].CurrentHubId
            }
          })
          .catch((httpException) => {
            this.UpdateCurrentHubId = this.LostShipInfo.currentHubID
            console.error('exception is:::::::::', httpException)
          })
      }
    },
    ShowShipmentLog(userid) {
      this.$validator.reset();
      this.errors.clear();
      axios.get(apiUrl.api_url + `external/getshipmentlog?ShippingID=${userid}`)
        .then((response) => {
          this.shipmentlogmodal = true;
            if(response.data.code===200){
            this.shipmentLog = response.data.data;
          }
          else {
            this.shipmentLog = [];
          }
        })
        .catch((httpException) => {
          this.$alertify.success("Shpment Log data not found");
          console.error('exception is:::::::::', httpException)
        })

    },
    closeShipmentLogModal() {
      this.shipmentlogmodal = false;
      this.$validator.reset();
      this.errors.clear();
    },
    selectAll(ev) {
      this.userIds = [];
      if (ev.target.checked == true) {
        this.DebitUserSelectedOptions = []
        for (let user in this.users) {
          this.DebitUserSelectedOptions.push(this.users[user]);
        }
      } else {
        this.DebitUserSelectedOptions = []
      }
      this.changeloadEmployess();
    },
    // customBConfigLabel ({ BusinessConfig }) {
    //   console.log('users',BusinessConfig);
    //   return `${BusinessConfig}`
    // },
    customBConfigLabel({ EmpTypeName, EmpCategoryId, EmpTypeId }) {
      return `${EmpTypeName}`
    },
    userObj(obj) {
      // console.log('object',obj);
      //this.userIds.push(obj.EmpTypeId);
    },
    resetDropdown() {
      this.DebitUserSelectedOptions = []
    },
    changeloadEmployess() {
      this.debitCatSelected = [];
      if (this.DebitUserSelectedOptions.length > 0) {
        for (let debitCatID in this.DebitUserSelectedOptions) {
          this.debitCatSelected.push(this.DebitUserSelectedOptions[debitCatID].EmpTypeId)
          //console.log('this.userIds ---->>>',this.debitCatSelected);
        }
        this.selectAlluser = this.DebitUserSelectedOptions.length == this.users.length ? true : false;
        this.LoadEmployees();

      } else {
        this.debitCatSelected = [];
        this.LoadEmployees(true);
      }
    },
    selectItems(getevent) {
      this.selectedItems = []
      if (getevent.target.checked == true) {
        for (let emp in this.empDetails) {
          let val = `${this.empDetails[emp][this.keyName]}${this.empDetails[emp][this.keyUserId]}`;
          this.selectedItems.push(val);
          // this.selectedItems.push(this.empDetails[emp].username.toString());
        }
      } else {
        for (let emp in this.empDetails) {
          this.debitPersonAmount[`${this.empDetails[emp][this.keyName]}${this.empDetails[emp][this.keyUserId]}`] = '';
          this.debitPersonPercent[`${this.empDetails[emp][this.keyName]}${this.empDetails[emp][this.keyUserId]}`] = '';
        }
        this.selectedItems = [];
        this.adjustDebitAmount = 0;
      }
      this.selectedfilteredEmpCount = this.selectedItems.length
      this.calculateDebitAmout(this.TotalSum, 100);
    },

    BindDebitFrom() {
      this.clear();
      let Debitfrom = this.LostShipInfo.DebitFrom;
      if (Debitfrom == 'ServiceCenter' ) {
        this.DebitModeObj = [{ "id": "Cash In Hand", "Debit_mode": "Cash In Hand" }, { "id": "Salary", "Debit_mode": "Salary" }]
        //getParentHub start

        if (this.hubdetails != '' && this.hubdetails != undefined) {

          axios.post(apiUrl.api_url + 'external/getParentHubs', { "HubID": this.hubdetails })
            .then((response) => {
              if (response.data.code === 200) {
                this.parentHubObj = response.data.data;
              }
              else {
                this.parentHubObj = [];
                this.$alertify.error(response.data.message);
              }
            })
            .catch((httpException) => {
              this.$alertify.error("parent hub data not found");
              console.error('exception is:::::::::', httpException)
            })  //getParentHub end
        }

        if(this.isLostNewFeaturesisOnThisHub) {
            this.LoadEmployees();
        } else {

          this.debitCatLoader = this.loader;
          let apiendpoint = 'external/GetEmployeeTypeMasterList';
          if (keycloak.enableKavach) {
            apiendpoint = 'user/migration/getemployeetypemasterlist';
          }
          axios.post(apiUrl.api_url + apiendpoint, { "appkey": "$LAST$Mile%#$" })
            .then((response) => {
              if (response.data.code === 200) {

                this.users = response.data.FilterdData.rows;
                this.debitCatLoader = "";
                // this.users.unshift({
                //   EmpTypeId: 'all',
                //   EmpTypeName: 'Select All'
                // })
              }
              else {
                this.users = [];
                this.$alertify.error(response.data.message);
              }
            })
            .catch((httpException) => {
              this.$alertify.error("UserCategory data not found");
              console.error('exception is:::::::::', httpException)
            })
        }
      } else if (Debitfrom == 'Courier') {

        this.DebitModeObj = [{ "id": "Cash", "Debit_mode": "Cash" },
        { "id": "Cheque", "Debit_mode": "Cheque" },
        { "id": "Invoice", "Debit_mode": "Invoice" },
        { "id": "COF", "Debit_mode": "COF" }];

        if (this.hubdetails != '' && this.hubdetails != undefined) {

          axios.post(apiUrl.api_url + 'external/OutSourcingAgentLIst', { "HubID": this.hubdetails, "EntityType": "Agent" })
            .then((response) => {

              if (response.data.code === 200) {

                this.CourierObj = response.data.data;
                let courierData = response.data.data;
                let outsourcingCnt = courierData.length;
                for (let i = 0; i < outsourcingCnt; i++) {
                  this.oldcourieroutsourcingId[courierData[i].id] = courierData[i].OldOutSourcingMasterId;
                }
                //console.log('this.oldcourieroutsourcingId',this.oldcourieroutsourcingId.length);
              }
              else {
                this.CourierObj = [];
                this.LostShipInfo.Courier = '';
                this.$alertify.error(response.data.message);
              }
            })
            .catch((httpException) => {
              this.$alertify.error("Courier data not found");
              console.error('exception is:::::::::', httpException)
            })
        }

      } else if (Debitfrom == 'Coloader') {
        let reqObj = { ShippingID: this.globalShippingid, OptType: 'Coloader' }
        axios.post(apiUrl.api_url + 'external/getOptTypeDetails', reqObj)
          .then((response) => {
            if (response.data.code === 200) {
              this.ColoaderObj = response.data.data;
            }
            else {
              console.log('response.data', response.data);
              this.ColoaderObj = [];
              this.LostShipInfo.Coloader = '';
              this.$alertify.error(response.data.message != '' && response.data.message != undefined ? response.data.message : 'Coloader data not found.!')
              //this.$alertify.error(response.data.message);
            }
          })
          .catch((httpException) => {
            this.$alertify.error("Coloader data not found");
            console.error('exception is:::::::::', httpException)
          })

      } else if (Debitfrom == 'Vendor') {
        let reqObj = { ShippingID: this.globalShippingid, OptType: 'Vehicle Vendor' }
        axios.post(apiUrl.api_url + 'external/getOptTypeDetails', reqObj)
          .then((response) => {
            if (response.data.code === 200) {
              this.VendorObj = response.data.data;
            }
            else {
              this.VendorObj = [];
              this.LostShipInfo.Vendor = '';
              this.$alertify.error(response.data.message != '' && response.data.message != undefined ? response.data.message : 'Vehicle Vendor data not found.!')
              //this.$alertify.error(response.data.message);
            }
          })
          .catch((httpException) => {
            this.$alertify.error("Vendor data not found");
            console.error('exception is:::::::::', httpException)
          })

      } else if (Debitfrom == 'NetworkVendor') {
        let reqObj = { ShippingID: this.globalShippingid, OptType: 'Network Vendor' }
        axios.post(apiUrl.api_url + 'external/getOptTypeDetails', reqObj)
          .then((response) => {
            if (response.data.code === 200) {
              this.VendorObj = response.data.data;
            }
            else {
              this.VendorObj = [];
              this.LostShipInfo.Vendor = '';
              this.$alertify.error(response.data.message != '' && response.data.message != undefined ? response.data.message : 'Network Vendor data not found.!')
            }
          })
          .catch((httpException) => {
            this.$alertify.error("NetworkVendor data not found");
            console.error('exception is:::::::::', httpException)
          })
      }else if(Debitfrom == "RSC"){
      this.DebitModeObj = [{ "id": "Cash In Hand", "Debit_mode": "Cash In Hand" }, { "id": "Salary", "Debit_mode": "Salary" }]
        // this.hubdetails=1001
        if (this.hubdetails != '' && this.hubdetails != undefined) {
            let reqObj = { HubIds: [this.hubdetails], ShippingID: this.globalShippingid, }
            console.log("reqObj", reqObj)
            axios.post(apiUrl.api_url + 'external/RSC/OwnerPartnerList/by/HubId', reqObj)
              .then((response) => {
                if (response.data.code === 200) {
                  if(response.data.data.length>0){
                    this.RSCObj=response.data.data;
              }else{
                this.$alertify.error('RSC data not found.!')
              }

            }
            else {
              this.RSCObj = [];
              this.LostShipInfo.RSC = '';
              this.$alertify.error(response.data.message != '' && response.data.message != undefined ? response.data.message : 'RSC data not found.!')
              //this.$alertify.error(response.data.message);
            }
          })
          .catch((httpException) => {
            this.$alertify.error("RSC data not found");
            console.error('exception is:::::::::', httpException)
          })

          axios.post(apiUrl.api_url + 'external/getParentHubs', { "HubID": this.hubdetails })
            .then((response) => {
              if (response.data.code === 200) {
                this.parentHubObj = response.data.data;
              }
              else {
                this.parentHubObj = [];
                this.$alertify.error(response.data.message);
              }
            })
            .catch((httpException) => {
              this.$alertify.error("parent hub data not found");
              console.error('exception is:::::::::', httpException)
            })  //getParentHub end
        }

        if(this.isLostNewFeaturesisOnThisHub) {
            this.LoadEmployees();
        } else {
        this.debitCatLoader = this.loader;
        let apiendpoint = 'external/GetEmployeeTypeMasterList';
        if (keycloak.enableKavach) {
          apiendpoint = 'user/migration/getemployeetypemasterlist';
        }
        axios.post(apiUrl.api_url + apiendpoint, { "appkey": "$LAST$Mile%#$" })
          .then((response) => {
            if (response.data.code === 200) {

              this.users = response.data.data.rows;
              this.debitCatLoader = "";
              // this.users.unshift({
              //   EmpTypeId: 'all',
              //   EmpTypeName: 'Select All'
              // })
            }
            else {
              this.users = [];
              this.$alertify.error(response.data.message);
            }
          })
          .catch((httpException) => {
            this.$alertify.error("UserCategory data not found");
            console.error('exception is:::::::::', httpException)
          })
        }
        console.log("hubDetails", this.TableDetails, this.hubdetails)


      }
      else if(Debitfrom == "BranchDebit"){

        this.DebitModeObj = [{
          "id": "Cash",
          "Debit_mode": "Cash"
        },
        {
          "id": "Cheque",
          "Debit_mode": "Cheque"
        },
        {
          "id": "Invoice",
          "Debit_mode": "Invoice"
        },
        {
          "id": "COF",
          "Debit_mode": "COF"
        }
      ];

        let getHubList = localStorage.getItem('allhubaccesslist');
        var byteHub = CryptoJS.AES.decrypt(getHubList.toString(), this.userDataKey);
        var hubList = byteHub.toString(CryptoJS.enc.Utf8);
        this.hubList = JSON.parse(hubList);
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>", this.hubList)
      }
    },
    calculateDebitAmout(DebitAmount, percentVal = 100, userid = '') {
      if (this.selectedItems.length > 0) {
        this.isDebitPersonSelected = this.selectedItems.length;
        if (userid != '' && document.getElementById(userid).checked == false) {
          this.debitPersonAmount[userid] = '';
          this.debitPersonPercent[userid] = '';
        }
        let selectDebitUsercount = this.selectedItems.length;

        let percentage = 0;
        let amount = 0;
        if (DebitAmount == '' || DebitAmount == 0 || DebitAmount == 'undefined') {
          percentage = 0;
          amount = 0;
        } else {
          percentage = (parseFloat(percentVal) / parseFloat(selectDebitUsercount)).toFixed(2);
          amount = (parseFloat(DebitAmount) / parseFloat(selectDebitUsercount)).toFixed(2);
        }
        let adjustDebitAmount = 0;
        let raiseDebitAmount = 0;

        for (let i = 0; i < selectDebitUsercount; i++) {
          raiseDebitAmount = parseFloat(raiseDebitAmount) + parseFloat(amount);
          this.debitPersonAmount[this.selectedItems[i]] = parseFloat(amount);
          this.debitPersonPercent[this.selectedItems[i]] = parseFloat(percentage);
        }
        this.adjustDebitAmount = (parseFloat(DebitAmount) - parseFloat(raiseDebitAmount)).toFixed(2);
      } else {
        this.isDebitPersonSelected = "";
        this.debitPersonAmount[userid] = 0;
        this.debitPersonPercent[userid] = 0;
      }
      this.selectedfilteredEmpCount = this.selectedItems.length

    },
    adjustDebitPercenatge(getUserId) {
      let getdebitshareAmount = this.debitPersonAmount[getUserId];
      let getpercentage = this.debitPersonPercent[getUserId];
      let DebitAmount = this.TotalSum;
      let percentage = 0;

      if (getdebitshareAmount != '') {
        if (parseFloat(getdebitshareAmount) > parseFloat(DebitAmount)) {
          document.getElementById('debitshare' + getUserId).classList.add("validate-error");
          this.$alertify.error("Entered amount should not be greater than debit amount");
          document.getElementById('debitshare' + getUserId).focus();
          this.isAPICallFlag = false;
        } else {
          let selectedUser = this.selectedItems.length;
          for (let i = 0; i < selectedUser; i++) {
            document.getElementById('debitshare' + this.selectedItems[i]).classList.remove("validate-error");
            document.getElementById('percentage' + this.selectedItems[i]).classList.remove("validate-error");
          }
          this.isAPICallFlag = true;
        }
        percentage = ((parseFloat(getdebitshareAmount) / parseFloat(DebitAmount)) * 100).toFixed(2);
        this.debitPersonPercent[getUserId] = parseFloat(percentage);

      } else {
        this.isAPICallFlag = false;
        this.debitPersonAmount[getUserId] = 0;
        this.debitPersonPercent[getUserId] = 0;
        let filteredAry = this.selectedItems.filter(function (e) { return e !== getUserId });
        this.selectedItems = filteredAry;
        //this.$alertify.error("false");
      }
      let totaleDebitAmount = parseFloat(DebitAmount) - parseFloat(this.debitPersonAmount[getUserId]);
      let totaleDebitPercent = (parseFloat(100) - parseFloat(percentage)).toFixed(2);
      let filteredAry = this.selectedItems.filter(function (e) { return e !== getUserId });
      let getNewUpdatepercent = this.debitPersonPercent[getUserId];
      this.selectedItems = filteredAry;
      this.calculateDebitAmout(totaleDebitAmount, totaleDebitPercent);
      if (getdebitshareAmount != 0) {
        this.selectedItems.splice(0, " ", getUserId);
      }
      if (this.selectedItems.length > 0) {
        this.isDebitPersonSelected = this.selectedItems.length;
      } else {
        this.isDebitPersonSelected = "";
      }

    },

    adjustDebitAmout(getUserId) {
      let getpercentage = this.debitPersonPercent[getUserId];

      let DebitAmount = this.TotalSum;

      if (getpercentage != '') {
        if (getpercentage > 100) {
          document.getElementById('percentage' + getUserId).classList.add("validate-error");
          this.$alertify.error("Entered percent should not be greater than 100%");
          document.getElementById('percentage' + getUserId).focus();
          this.isAPICallFlag = false;
        } else {
          let selectedUser = this.selectedItems.length;
          for (let i = 0; i < selectedUser; i++) {
            document.getElementById('debitshare' + this.selectedItems[i]).classList.remove("validate-error");
            document.getElementById('percentage' + this.selectedItems[i]).classList.remove("validate-error");
          }
          this.isAPICallFlag = true;
        }
        let Amount = ((parseFloat(DebitAmount) / parseFloat(100)) * parseFloat(getpercentage)).toFixed(2);
        this.debitPersonAmount[getUserId] = parseFloat(Amount);
      } else {
        getpercentage = 0;
        this.isAPICallFlag = false;
        this.debitPersonAmount[getUserId] = 0;
        this.debitPersonPercent[getUserId] = 0;
        let filteredAry = this.selectedItems.filter(function (e) { return e !== getUserId });
        this.selectedItems = filteredAry;

      }

      let getdebitshareAmount = this.debitPersonAmount[getUserId];
      let totaleDebitAmount = parseFloat(DebitAmount) - parseFloat(getdebitshareAmount);
      let totaleDebitPercent = (parseFloat(100) - parseFloat(getpercentage)).toFixed(2);
      let filteredAry = this.selectedItems.filter(function (e) { return e !== getUserId });
      //console.log('Totaldebit',totaleDebitAmount,'totaltdebitpercent:',totaleDebitPercent);
      this.selectedItems = filteredAry;
      this.calculateDebitAmout(totaleDebitAmount, totaleDebitPercent);
      if (getpercentage != 0) {
        this.selectedItems.splice(0, " ", getUserId);
      }
      if (this.selectedItems.length > 0) {
        this.isDebitPersonSelected = this.selectedItems.length;
      } else {
        this.isDebitPersonSelected = "";
      }
    },
    calculateTotalEnteredAmt() {
      let len = this.selectedItems.length;
      let debitTotal = 0;
      let checkReminder = this.adjustDebitAmount.split(".")
      if (checkReminder[0] != 0) {
        this.$alertify.error("Balance to be Adjust amount should be less than zero, Please adjust amount.!")
        this.isAPICallFlag = false;
        this.amountExceedError = true
        return false;
      } else {
        for (let i = 0; i < len; i++) {
          let debitshare = this.debitPersonAmount[this.selectedItems[i]];
          debitTotal = parseFloat(debitTotal) + parseFloat(debitshare);
        }
        console.log('debitTotal', debitTotal);
        debitTotal = parseFloat(debitTotal) + parseFloat(this.adjustDebitAmount);

        if (parseFloat(debitTotal).toFixed(1) === parseFloat(this.TotalSum).toFixed(1)) {
          this.isAPICallFlag = true;
        } else {
          this.$alertify.error("Debit amount not matched");
          this.isAPICallFlag = false;
          this.amountExceedError = true
        }
      }
    },


    validateForm(scope) {
      if(this.$route.query.shippingid){
        this.raiseDebitandMarkLost(scope)
      }else if (this.$route.query.id) {
        this.raiseDebitandMarkLost(scope)
      }else{
        this.$alertify.error("No data found for raise debit")
      }
    },
    raiseDebit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if(this.LostShipInfo.DebitFrom =='ServiceCenter' && this.selectedItems.length > 0){
          this.calculateTotalEnteredAmt();
        }
        if(result && this.isAPICallFlag==true && this.LostShipInfo.DebitAmount != 0){
          var DebitPersonDetailsP = [];
          //var isAPICallFlag = true;
          this.isSaveLoading = true;
          if(this.LostShipInfo.DebitFrom =='ServiceCenter' && this.selectedItems.length > 0){

              let len = this.selectedItems.length;
              let debitTotal = 0;
              //console.log('useids : ', this.selectedItems);

              for(let i = 0; i<len ; i++){

                let debitshare = this.debitPersonAmount[this.selectedItems[i]];
                let percentage = this.debitPersonPercent[this.selectedItems[i]];
                //let percentage = document.getElementById('percentage'+this.selectedItems[i]).value;
                let oldUserId = document.getElementById('olduserid'+this.selectedItems[i]).value;
                if(debitshare != '' && percentage != ''){
                  debitTotal = parseFloat(debitTotal) + parseFloat(debitshare);
                  let shippingIDConvertTosrting = (this.LostShipInfo.shippingid).toString();
                  let empdetailsObj = this.empDetails;
                  let debitFormName = empdetailsObj.find(empid =>  `${empid[this.keyName]}${empid[this.keyUserId]}` == this.selectedItems[i] );
                  // console.log('debitFormName',debitFormName);
                  // console.log('debitFormName',debitFormName.username);

                  DebitPersonDetailsP.push({
                    "ShippingID":shippingIDConvertTosrting,
                    "HubID":this.UpdateCurrentHubId,
                    // "DeliveryUserID":this.selectedItems[i],
                    "DeliveryUserID":debitFormName.userid,
                    "DebitFromType":this.LostShipInfo.DebitFrom,
                    "DebitAmount":debitshare,
                    "DebitPercentage":percentage,
                    "Status":this.LostShipInfo.status,
                    "Comments":this.comments,
                    "olduserid":oldUserId,
                    "DebitFrom" : debitFormName.username,
                    "CreatedBy":this.localusermailid,
                    "OutSourcingID": debitFormName.OutSourcingID
                  })
                }
              }
          }

          DebitPersonDetailsP.length > 0 ? DebitPersonDetailsP : '';

          //Raise Debit API Integration start here
          let shippingIDTosrting = (this.LostShipInfo.shippingid).toString();
          this.shippingIdForMeta = shippingIDTosrting
          let olduserIds;
          let debitFromVendorName;
          if(this.LostShipInfo.DebitFrom == 'Vendor' || this.LostShipInfo.DebitFrom == 'NetworkVendor'){
            olduserIds = this.LostShipInfo.Vendor;
            debitFromVendorName = ($('#Vendor option:selected').text()).trim();
          }else if( this.LostShipInfo.DebitFrom == 'Coloader' ){
            olduserIds = this.LostShipInfo.Coloader;
            debitFromVendorName = ($('#Coloader option:selected').text()).trim();
          }else if( this.LostShipInfo.DebitFrom == 'Courier' ){
            olduserIds = this.oldcourieroutsourcingId[this.LostShipInfo.Courier];
            debitFromVendorName = ($('#Courier option:selected').text()).trim();
          }
          else if( this.LostShipInfo.DebitFrom == 'BranchDebit'){
            olduserIds = this.LostShipInfo.CurrentHubID;
            DebitID =this.LostShipInfo.CurrentHubID;
            debitFromVendorName = this.LostShipInfo.BranchDebit;
          }
          let resLen = this.TableDetails.length
          let GstAmount;
          for (let i = 0; i < resLen; i++) {
            if (this.TableDetails[i].Gst == false) {
              GstAmount = this.GstValue;
            } else {
              GstAmount = 0;
            }
            if (this.TableDetails[i].Penalty == null || this.TableDetails[i].Penalty == undefined) {
              this.TableDetails[i].Penalty = 0
            }
          }
          //console.log('olduserIds',olduserIds);
          let RaiseDebitPayload = {
              "ShippingID": shippingIDTosrting,
              "HubID": this.UpdateCurrentHubId,
              "HubName": this.LostShipInfo.currentHub,
              "HubLocation": "",
              "ClientID": this.ClientID,
              "ClientName": this.ClientName,
              "HubZoneID": this.LostShipInfo.currentHubZoneID,
              "HubZoneName": this.CurrentHubZoneName,
              "DebitFromType": this.LostShipInfo.DebitFrom,
              "DebitMode": this.LostShipInfo.DebitMode,
              "NetPayment": this.LostShipInfo.netAmt,
              "NetShipmentValue": this.LostShipInfo.DebitAmount,
              "DebitAmount": this.LostShipInfo.DebitAmount,
              "OctroiMRP":this.LostShipInfo.NetShipmentValue,
              "PenaltyAmount": this.TableDetails[0].Penalty,
              "IsGST": this.TableDetails[0].Gst,
              "GSTAmount": GstAmount,
              "TotalDebitAmount": this.TableDetails[0].TotalDebitAmt,
              "Comments": this.comments,
              "DocketNumber": this.DocketNumber,
              "CreatedBy": this.localusermailid,
              "DebitPersonDetails" : DebitPersonDetailsP,
              "adjustDebitAmount":this.adjustDebitAmount,
              "ColoaderID":this.LostShipInfo.Coloader!=""?this.LostShipInfo.Coloader:undefined,
              "VehicleVendorID":this.LostShipInfo.Vendor!=""?this.LostShipInfo.Vendor:undefined,
              "CourierID":this.LostShipInfo.Courier!=""?this.LostShipInfo.Courier:undefined,
              "Attachment" : this.attachmentPath,
              "BankChalanNo" : this.ChallanNumber,
              "olduserid" : olduserIds,
              "DebitFrom" : debitFromVendorName,
              "CenterType": this.TableDetails[0].CenterType,
              "Vertical" : this.TableDetails[0].Vertical,
              "ShipmentType" :this.TableDetails[0].ShipmentType,
              "AOR":  this.TableDetails[0].AOR
            }
            // console.log('RaiseDebitPayload',RaiseDebitPayload);
            axios.post(apiUrl.api_url + 'shipmentLost/RaiseDebit', RaiseDebitPayload)
             .then((response) => {

                 if(response.data.code === 200){
                   //tracker api called here
                  let TrackerInfo = {
                    projectname:"Last Mile",
                    type:"Web",
                    userid:this.localuserid,
                    username:this.localusermailid,
                    meta: {
                        "event":"saveHubMarkLostDebit",
                        "shippingId" : this.shippingIdForMeta,
                        "DebitMode": this.LostShipInfo.DebitMode,
                        "NetPayment": this.LostShipInfo.netAmt,
                        "Comments": this.comments,
                        "DocketNumber": this.DocketNumber,
                        "ColoaderID":this.LostShipInfo.Coloader!=""?this.LostShipInfo.Coloader:undefined,
                        "VehicleVendorID":this.LostShipInfo.Vendor!=""?this.LostShipInfo.Vendor:undefined,
                        "CourierID":this.LostShipInfo.Courier!=""?this.LostShipInfo.Courier:undefined,
                        "BankChalanNo" : this.ChallanNumber
                    }
                  }
                  this.PageTracker(TrackerInfo);
                  //end
                     this.$alertify.success("Raise debit successful");
                     this.$router.push('/RaiseDebit');
                 } else if(response.data.code === 202){
                   this.$alertify.error("Shipment already marked lost");
                   this.$router.push('/RaiseDebit');
                 } else {
                     this.$alertify.error(response.data.message);
                 }
                 this.isSaveLoading = false
             })
             .catch((httpException) => {
                 this.isSaveLoading = false
                 this.$alertify.error("Unable to update raise debit");
                 console.error('exception is:::::::::', httpException)
             })
           //Raise Debit API Integration end
        } else {
          if(this.LostShipInfo.DebitAmount == 0) {
            this.$alertify.error("Net payment or octroi amount must be greater than Zero");
          } else {
            this.$alertify.error("Please check Validation failed .!");
          }
        }
      });
  },

    raiseDebitandMarkLost(scope){
      this.search="";
      this.$validator.validateAll(scope).then(result => {
        let tablelength = this.TableDetails.length
        let ShipmentDetails
        if (this.LostShipInfo.DebitFrom == 'ServiceCenter' && this.selectedItems.length > 0) {
          this.calculateTotalEnteredAmt();
        }
        if (result && this.isAPICallFlag == true && this.TotalSum != 0) {
          // if (this.TableDetails[0].IsRSC == '1') {
          //   ShipmentDetails = this.rscShipmentPayload()
          // }else {
          let RaisedebitpayloadARR = []

          for(let j=0; j<tablelength; j++){

          var DebitPersonDetailsP = [];
          //var isAPICallFlag = true;
          this.isSaveLoading = true;
          let DebitID;
          if (this.LostShipInfo.DebitFrom == 'ServiceCenter' && this.selectedItems.length > 0) {
            let len = this.selectedItems.length;
            let debitTotal = 0;
            for (let i = 0; i < len; i++) {
              let debitshare = this.debitPersonAmount[this.selectedItems[i]];
              let percentage = this.debitPersonPercent[this.selectedItems[i]];
              let oldUserId = document.getElementById('olduserid' + this.selectedItems[i]).value;
              if (debitshare != '' && percentage != '') {
                debitTotal = parseFloat(debitTotal) + parseFloat(debitshare);
                let empdetailsObj = this.empDetails;
                let shippingIDConvertTosrting = (this.LostShipInfo.shippingid).toString();
                let debitFormName = empdetailsObj.find(empid => `${empid[this.keyName]}${empid[this.keyUserId]}` == this.selectedItems[i]);
                DebitPersonDetailsP.push({
                  "DeliveryUserID": debitFormName.userid,
                  "DebitFromType": this.LostShipInfo.DebitFrom,
                  "DebitPercentage": percentage,
                  "Comments": this.comments,
                  "olduserid": oldUserId,
                  "DebitFrom": debitFormName.username,
                  "CreatedBy": this.localusermailid,
                  "OutSourcingID": debitFormName.OutSourcingID,
                  "employeeId": debitFormName.EmployeeID
                })
              }
            }
          }

          if (this.LostShipInfo.DebitFrom == 'RSC' && this.selectedItems.length > 0) {
            let len = this.selectedItems.length;
            let debitTotal = 0;
            for (let i = 0; i < len; i++) {
              let debitshare = this.debitPersonAmount[this.selectedItems[i]];
              let percentage = this.debitPersonPercent[this.selectedItems[i]];
              // let oldUserId = document.getElementById('olduserid' + this.selectedItems[i]).value;
              DebitID =this.LostShipInfo.RSC;
              if (debitshare != '' && percentage != '') {
                debitTotal = parseFloat(debitTotal) + parseFloat(debitshare);
                let empdetailsObj = this.empDetails;
                let shippingIDConvertTosrting = (this.LostShipInfo.shippingid).toString();
                let debitFormName = empdetailsObj.find(empid => `${empid[this.keyName]}${empid[this.keyUserId]}` == this.selectedItems[i]);
                DebitPersonDetailsP.push({
                  "UserID": debitFormName.userid,
                  "DebitFromType": this.LostShipInfo.DebitFrom,
                  "DebitPercentage": percentage,
                  "SRName": debitFormName.username,
                  "CreatedBy": this.localusermailid,
                  "SRAgencyID": debitFormName.OutSourcingID,
                })
              }
            }
          }

          DebitPersonDetailsP.length > 0 ? DebitPersonDetailsP : '';
          let olduserIds;
          let debitFromVendorName;

          if (this.LostShipInfo.DebitFrom == 'Vendor' || this.LostShipInfo.DebitFrom == 'NetworkVendor') {
            olduserIds = this.LostShipInfo.Vendor;
            debitFromVendorName = ($('#Vendor option:selected').text()).trim();
          } else if (this.LostShipInfo.DebitFrom == 'Coloader') {
            olduserIds = this.LostShipInfo.Coloader;
            debitFromVendorName = ($('#Coloader option:selected').text()).trim();
          } else if (this.LostShipInfo.DebitFrom == 'Courier') {
            olduserIds = this.oldcourieroutsourcingId[this.LostShipInfo.Courier];
            debitFromVendorName = ($('#Courier option:selected').text()).trim();
          }else if (this.LostShipInfo.DebitFrom == 'RSC') {
            olduserIds = this.LostShipInfo.RSC;
            DebitID =this.LostShipInfo.RSC;
            debitFromVendorName = ($('#RSC option:selected').text()).trim();
          }
          else if (this.LostShipInfo.DebitFrom == 'BranchDebit') {
            olduserIds = this.LostShipInfo.currentHubID;
            DebitID =this.LostShipInfo.currentHubID;
            debitFromVendorName = this.LostShipInfo.BranchDebit;
          }
          let GstAmount;
            if (this.TableDetails[j].Gst == false) {
              GstAmount = this.GstValue;
            } else {
              GstAmount = 0;
            }
            if(this.TableDetails[j].Penalty == null ||this.TableDetails[j].Penalty == undefined){
              this.TableDetails[j].Penalty = 0
            }
            let shippingIDTosrting = (this.TableDetails[j].ShippingID).toString();
            this.shippingIdForMeta = shippingIDTosrting
          let RaiseDebitPayload = {
            "ShippingID": shippingIDTosrting,
            "HubID": this.hubdetails,
            "HubName": this.TableDetails[j].CurrentHubName,
            "HubLocation": "",
            "ClientID": this.TableDetails[j].ClientID,
            "ClientName": this.TableDetails[j].ClientName,
            "HubZoneID": this.TableDetails[j].CurrentHubZoneID,
            "HubZoneName": this.TableDetails[j].CurrentHubZoneName,
            "DebitFromType": this.LostShipInfo.DebitFrom,
            "DebitMode": this.LostShipInfo.DebitMode,
            "NetPayment": this.TableDetails[j].NetPayment,
            "NetShipmentValue": this.TableDetails[j].GreaterDebitAMt,
            "DebitAmount": this.TableDetails[j].GreaterDebitAMt,
            "OctroiMRP": this.TableDetails[j].OctroiMRP,
            "PenaltyAmount":this.TableDetails[j].Penalty,
            "IsGST": this.TableDetails[j].Gst,
            "GSTAmount": GstAmount,
            "TotalDebitAmount": this.TableDetails[j].TotalDebitAmt,
            "Comments": this.comments,
            "DocketNumber": this.DocketNumber,
            "CreatedBy": this.localusermailid,
            "DebitPersonDetails": DebitPersonDetailsP,
            "adjustDebitAmount": this.adjustDebitAmount,
            "ColoaderID": this.LostShipInfo.Coloader != "" ? this.LostShipInfo.Coloader : undefined,
            "VehicleVendorID": this.LostShipInfo.Vendor != "" ? this.LostShipInfo.Vendor : undefined,
            "CourierID": this.LostShipInfo.Courier != "" ? this.LostShipInfo.Courier : undefined,
            "Attachment": this.attachmentPath,
            "BankChalanNo": this.ChallanNumber,
            "olduserid": olduserIds,
            "DebitID":DebitID,
            "DebitFrom": debitFromVendorName,
            "ShipmentType" :this.TableDetails[j].ShipmentType,
            "Vertical" : this.TableDetails[j].Vertical,
            "CenterType": this.TableDetails[j].CenterType,
            "AOR": this.TableDetails[j].AOR,
            "jobProfile": this.userInfo.jobProfile
          }
          if (this.$route.query.reason){
            RaiseDebitPayload.LostReason = this.$route.query.reason[0]
            RaiseDebitPayload.SubLostReason = this.$route.query.reason[1]
          }
          RaisedebitpayloadARR.push(RaiseDebitPayload);
        }
        ShipmentDetails = {RaisedebitpayloadARR}
        console.log("-=-=-=-=-==========================", ShipmentDetails)
      // }
      let route = ''
        if(this.$route.query.shippingid){
          route = 'shipmentLost/pushRaiseDebitDataInSQS';
        }else if (this.$route.query.id) {
          route = 'shipmentLost/raiseDebitAndMarkLost';
        }
          axios.post(apiUrl.api_url + route, ShipmentDetails)
            .then((response) => {
              if (response.data.code == 200 && this.$route.query.shippingid){
                this.$alertify.success(response.data.message);
                this.$router.push('/RaiseDebit');
              }else if ((response.data.code == 202 || response.data.code == 204) && this.$route.query.shippingid){
                this.$alertify.error(response.data.message);
                this.$router.push('/RaiseDebit');
              }else if (response.data.code === 200 && this.$route.query.id) {
                //tracker api called here
                let TrackerInfo = {
                  projectname: "Last Mile",
                  type: "Web",
                  userid: this.localuserid,
                  username: this.localusermailid,
                  meta: {
                    "event": "saveHubMarkLostDebit",
                    "shippingId": this.shippingIdForMeta,
                    "DebitMode": this.LostShipInfo.DebitMode,
                    "NetPayment": this.LostShipInfo.netAmt,
                    "Comments": this.comments,
                    "DocketNumber": this.DocketNumber,
                    "ColoaderID": this.LostShipInfo.Coloader != "" ? this.LostShipInfo.Coloader : undefined,
                    "VehicleVendorID": this.LostShipInfo.Vendor != "" ? this.LostShipInfo.Vendor : undefined,
                    "CourierID": this.LostShipInfo.Courier != "" ? this.LostShipInfo.Courier : undefined,
                    "BankChalanNo": this.ChallanNumber
                  }
                }
                this.PageTracker(TrackerInfo);
                //end
              this.apiResponseforTable = response.data.data
              let Reslength = this.apiResponseforTable.length
              for(let i=0; i<Reslength; i++){
                if (Object.keys(this.apiResponseforTable[i]).length!=0){
                    this.apiResponseforTable[i].ShippindIds = response.data.data[i].ShippindIds.toString()
                }
              }
              if (this.apiResponseforTable.find(o => o.code !== 200) ) {
                this.modelValue = true;
              } else {
                this.$alertify.success(this.apiResponseforTable[0].message);
                this.$router.push('/MarkLostShipment');
              }
              } else {
                this.$alertify.error(response.data.message);
              }
              this.isSaveLoading = false
            })
            .catch((httpException) => {
              this.isSaveLoading = false
              this.$alertify.error("Unable to update raise debit");
              console.error('exception is:::::::::', httpException)
            })
          //Raise Debit API Integration end
        } else {
          if (this.TotalSum == 0) {
            this.$alertify.error("Net payment or octroi amount must be greater than Zero");
          } else {
            this.$alertify.error("Please check Validation failed .!");
          }
        }
      });
    },

    rscShipmentPayload() {
      let tablelength = this.TableDetails.length
        let RaisedebitpayloadARR = []
        for (let j = 0; j < tablelength; j++) {
          let DebitPersonDetailsP = [];
          this.isSaveLoading = true;
              let debitshare = parseFloat(this.TableDetails[j].OctroiMRP) > parseFloat(this.TableDetails[j].NetPayment) ? parseFloat(this.TableDetails[j].OctroiMRP) : parseFloat(this.TableDetails[j].NetPayment);
              let percentage = 100;
              if (debitshare != '' && percentage != '') {
                let shippingIDConvertTosrting = (this.TableDetails[j].ShippingID).toString();
                let debitFormName = this.TableDetails[j].NotifyNoInfoDetail
                DebitPersonDetailsP.push({
                  "DeliveryUserID": debitFormName.RSCMasterId,
                  "DebitFromType": 'ServiceCenter',
                  "DebitPercentage": percentage,
                  "Comments": this.comments,
                  "olduserid": "",
                  "DebitFrom": debitFormName.rscownername,
                  "CreatedBy": this.localusermailid,
                  "OutSourcingID": debitFormName.OutSourcingID
                })
              }
          DebitPersonDetailsP.length > 0 ? DebitPersonDetailsP : '';
          let GstAmount;
            if (this.TableDetails[j].Gst == false) {
              GstAmount = this.GstValue;
            } else {
              GstAmount = 0;
            }
            if(this.TableDetails[j].Penalty == null ||this.TableDetails[j].Penalty == undefined){
              this.TableDetails[j].Penalty = 0
            }
          let shippingIDTosrting = (this.TableDetails[j].ShippingID).toString();
          this.shippingIdForMeta = shippingIDTosrting
          let olduserIds;
          let debitFromVendorName;
          let RaiseDebitPayload = {
            "ShippingID": shippingIDTosrting,
            "HubID": this.hubdetails,
            "HubName": this.TableDetails[j].CurrentHubName,
            "HubLocation": "",
            "ClientID": this.TableDetails[j].ClientID,
            "ClientName": this.TableDetails[j].ClientName,
            "HubZoneID": this.TableDetails[j].CurrentHubZoneID,
            "HubZoneName": this.TableDetails[j].CurrentHubZoneName,
            "DebitFromType": 'ServiceCenter',
            "DebitMode": this.LostShipInfo.DebitMode,
            "NetPayment": this.TableDetails[j].NetPayment,
            "NetShipmentValue": this.TableDetails[j].GreaterDebitAMt,
            "DebitAmount": this.TableDetails[j].GreaterDebitAMt,
            "OctroiMRP": this.TableDetails[j].OctroiMRP,
            "PenaltyAmount":this.TableDetails[j].Penalty,
            "IsGST": this.TableDetails[j].Gst,
            "GSTAmount": GstAmount,
            "TotalDebitAmount": this.TableDetails[j].TotalDebitAmt,
            "Comments": this.comments,
            "DocketNumber": this.DocketNumber,
            "CreatedBy": this.localusermailid,
            "DebitPersonDetails": DebitPersonDetailsP,
            "adjustDebitAmount": this.adjustDebitAmount,
            "ColoaderID": this.LostShipInfo.Coloader != "" ? this.LostShipInfo.Coloader : undefined,
            "VehicleVendorID": this.LostShipInfo.Vendor != "" ? this.LostShipInfo.Vendor : undefined,
            "CourierID": this.LostShipInfo.Courier != "" ? this.LostShipInfo.Courier : undefined,
            "Attachment": this.attachmentPath,
            "BankChalanNo": this.ChallanNumber,
            "olduserid": "",
            "DebitFrom": debitFromVendorName,
            "LostReason": this.$route.query.reason[0],
            "SubLostReason": this.$route.query.reason[1],
            "CenterType": this.TableDetails[j].CenterType,
            "Vertical" : this.TableDetails[j].Vertical,
            "ShipmentType" :this.TableDetails[j].ShipmentType,
            "AOR":  this.TableDetails[j].AOR
          }
          RaisedebitpayloadARR.push(RaiseDebitPayload);
        }
        let rscPayload = { RaisedebitpayloadARR }
        return rscPayload
    },
    closeApprovalResultModel() {
      this.modelValue = false
      this.$router.push('/MarkLostShipment');
    },

    LoadEmployees(isReset) {
      if (isReset) {
        this.empDetails = []
      } else {
        if (this.selectedRSCHubs.length === 0) {
          this.selectedRSCHubs.push(this.hubdetails);
        }
        this.selectedItems = [];
        this.debitPersonAmount = [];
        this.debitPersonPercent = [];
        //load all employess list with emptype and without emp type when select cat ALL / ROLLBACKED THIS CHANGE FROM LIVE.
        let Emppayload = {
          "appkey": '$LAST$Mile%#$',
          "HubId": this.selectedRSCHubs
        }
        if(this.isLostNewFeaturesisOnThisHub) {
          Emppayload.LoggedInUserJobProfile =  this.LoggedInUserJobProfile

          const dateStr = this.TableDetails[0].CreatedDate;
          const date = new Date(dateStr);
          const formatted = date.toISOString().split('T')[0];
          Emppayload.Date = formatted

        } else {
          let adminobject = this.users.filter((obj) => obj.EmpTypeName.trim().toLowerCase() == 'hub_executive');
          // console.log('Admin Object --------->>', adminobject);
            if(this.selectAlluser){
              console.log("this.debitSelected", this.debitCatSelected);
              if(adminobject.length>0 && this.debitCatSelected.includes(adminobject[0].EmpTypeId)){
                if(this.debitCatSelected.length == 1) {
                  this.utype = [2]
                  this.debitCatSelected = []
                }else{
                  let getidxref = this.debitCatSelected.indexOf(adminobject[0].EmpTypeId);
                    this.debitCatSelected.splice(getidxref, 1);
                    this.utype = [2,3]
                }
              }else{
                this.utype=[3]
              }
            }else if(adminobject.length > 0 && this.debitCatSelected.includes(adminobject[0].EmpTypeId)){
              if(this.debitCatSelected.length == 1) {
                this.utype = [2]
                this.debitCatSelected = []
              }else{
                let getidxref = this.debitCatSelected.indexOf(adminobject[0].EmpTypeId);
                  this.debitCatSelected.splice(getidxref, 1);
                  this.utype = [2,3]
              }
            }else{
                this.utype=[3]
              }

          // let Emppayload = {
          //   "appkey": '$LAST$Mile%#$',
          //   "HubId": this.selectedRSCHubs,
          //   "EmpType": this.debitCatSelected,
          //   "utype":  this.utype
          //   // "EmpType" : this.userIds
          // }
          Emppayload.EmpType =  this.debitCatSelected
          Emppayload.utype =  this.utype
        }
        console.log('Emppayload',Emppayload);
        this.isDebitPersonLoading = true;
        let apiendpoint = 'external/getHubEmpDetails';
        if (keycloak.enableKavach && !this.isLostNewFeaturesisOnThisHub) {
          apiendpoint = 'user/migration/gethubempdetails';
        }
        if (keycloak.enableKavach && this.isLostNewFeaturesisOnThisHub) {
          apiendpoint = 'user/v2/migration/gethubempdetailsv2';
        }
        axios.post(apiUrl.api_url + apiendpoint, { Emppayload })
          .then((response) => {
            if (response.data.code === 200) {
              //console.log('emp.getHubEmpDetails',response.data.data);
              this.empDetails = response.data.data;
            }
            else {
              this.empDetails = [];
              this.$alertify.error("Record Not found");
            }
            this.isDebitPersonLoading = false;
          })
          .catch((httpException) => {
            this.$alertify.error("Employee data not found");
            console.error('exception is:::::::::', httpException)
            this.isDebitPersonLoading = false;
          })
      }
    },
    onUpload(event) {
      this.getUploadError = [];
      const file = event.target.files[0];
      this.file = file;
      this.Loading = true;
      this.validated = false;

      //image upload code start here
      const formData = new FormData();
      formData.append('ShippingID', this.LostShipInfo.shippingid);
      formData.append('file', this.file);
      if (this.file.size <= 1024 * 1024 * 5) {

        axios.post(apiUrl.api_url + 'raiseDebit/LostFileUploads', formData)
          .then((response) => {
            if (response.data.code === 200) {
              this.getUploadError = [{ 'title': 'success', 'detail': 'file Uploaded successfully !!' }];
              this.attachmentPath = response.data.imageUrl;
              this.uploadError = this.getUploadError.length;
              console.log('this.attachmentPath', this.attachmentPath);
              this.validated = true;
            } else {
              this.uploadError = '';
              this.attachmentPath = '';
              this.getUploadError = response.data.errors;
              //console.log('this.getUploadError',this.getUploadError);
              // const input = this.$refs.FileUploadAcceptanceLetter;
              // input.type = 'text';
              // input.type = 'file';
              this.validated = false;
            }
            this.Loading = false;
          })
          .catch((httpException) => {
            console.error('exception is :::::::::', httpException)
            this.Loading = false;
            this.validated = true;
            this.isAPICallFlag = false;
          })
      } else {
        this.$alertify.error("Please check image size should be less than 5MB ");
        // const input = this.$refs.FileUploadAcceptanceLetter;
        // input.type = 'text';
        // input.type = 'file';
        this.validated = true;
        this.Loading = false;
      }
      //image upload code end here

    },
    resetTypeFilter() {
      this.userIds = [];
      this.DebitUserSelectedOptions = []
      this.debitCatSelected = []
      //document.getElementById('selectAlluser').checked = false;
      this.selectedItems = [];
      this.debitPersonAmount = [];
      this.debitPersonPercent = [];
      this.LoadEmployees(true);
    },
    onlyNumber: function ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 8) {
        $event.preventDefault();
      }
    },
    reset() {
      this.empDetails = []
      this.DebitUserSelectedOptions = []
      this.LostShipInfo.DebitFrom = '';
      this.selectedItems = [];
      this.selectAllItems = false;
      $("input:text").val('');
      this.clear();
      this.validated = true;
      this.TotalSum = 0;
      let resLen = this.TableDetails.length
            for(let i=0;i<resLen;i++){
              this.TableDetails[i].GstAmount = 0;
              this.TableDetails[i].Gst = true;
              this.TableDetails[i].Penalty = 0;
              this.TableDetails[i].TotalDebitAmt = this.TableDetails[i].GreaterDebitAMt;
              $(`#index_${i}`).html(this.TableDetails[i].GreaterDebitAMt)
              this.TotalSum = parseFloat(this.TotalSum) + parseFloat(this.TableDetails[i].GreaterDebitAMt);
             }
    },
    clear() {
      //this.LostShipInfo = '';

      this.LostShipInfo.DebitMode = '';
      this.LostShipInfo.Coloader = '';
      this.LostShipInfo.Courier = '';
      this.LostShipInfo.Vendor = '';
      // this.LostShipInfo.facility = '';
      this.DocketNumber = '';
      this.comments = '';
      this.attachmentPath = '';
      this.ChallanNumber = '';
      this.search = '';
      this.userIds = [];
      //document.getElementById('selectAlluser').checked = false;
      // const input = this.$refs.FileUploadAcceptanceLetter;
      // input.type = 'text';
      // input.type = 'file';
      this.uploadError = '';
      this.getUploadError = '';
      this.validated = true;
      this.$validator.reset();
      this.errors.clear();
    },
    toggleSortByType() {
      this.sortByTypeAsc = !this.sortByTypeAsc;
      // Move 'Type' to the end to make it the most recent sort
      this.sortPriority = this.sortPriority.filter(k => k !== 'Type');
      this.sortPriority.push('Type');
    },
    toggleSortByVertical() {
      this.sortByVerticalAsc = !this.sortByVerticalAsc;
      this.sortPriority = this.sortPriority.filter(k => k !== 'Vertical');
      this.sortPriority.push('Vertical');
    }
    // HubDetails(e){
    //   console.log("===>>><<<", e, this.LostShipInfo.facility)
    // }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/LOST/HubMarkLostDebit/HubMarkLostDebit.component.js